import React, { FunctionComponent } from "react";
import { useParams } from "react-router-dom";
import { useCompanyUsersByCompany, useTranslations, useCompanyByUuid } from "$hooks";

import { AdminCompanyUsersTable } from "$components/AdminCompanyUsersTable";
import { RoutesBuilder } from "../../../models/RoutesBuilder";
import { Button } from "../../../components/Button";

export const CompanyUsersContainer: FunctionComponent = () => {
  const { companyUuid } = useParams<{ companyUuid: string }>();
  const translations = useTranslations<{ title: string }>("adminCompanyUsersListMainTitle");
  const addUser = useTranslations<ITranslation>("companyUsers");
  const response = useCompanyUsersByCompany(companyUuid);
  const companyName = useCompanyByUuid({ uuid: companyUuid })?.companyName;

  return (
    <AdminCompanyUsersTable
      title={`${translations?.title} ${companyName}`}
      visibleActions={["deleteUser"]}
      companyUsers={response?.data?.getCompanyUsersByCompany.results}
      fetchMore={response.fetchMore}
      loading={response.loading}
      shouldFetchMore={response?.data?.getCompanyUsersByCompany.shouldFetchMore}
    >
      <Button link={RoutesBuilder.admin.createCompanyUser(companyUuid)} kind="primary">
        {addUser?.addAdminButtonLabel || ""}
      </Button>
    </AdminCompanyUsersTable>
  );
};

interface ITranslation {
  addAdminButtonLabel: string;
}
